var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var PC;
    (function (PC) {
        var SpotComponent;
        (function (SpotComponent) {
            var RateDetailView = (function (_super) {
                __extends(RateDetailView, _super);
                function RateDetailView(spotId) {
                    var _this = _super.call(this, { delegate: false }) || this;
                    _this.addClickEvent(spotId);
                    return _this;
                }
                RateDetailView.prototype.addClickEvent = function (spotId) {
                    $(".js-rate-detail-button-" + spotId).click(function () {
                        if ($(".js-rate-detail-content-" + spotId).css('display') === 'none') {
                            $(".js-rate-detail-content-" + spotId).css('display', 'flex');
                            $(".js-rate-detail-button-triangle-" + spotId).css('border-bottom', '4px solid #3E82E9');
                            $(".js-rate-detail-button-triangle-" + spotId).css('border-top', '');
                        }
                        else {
                            $(".js-rate-detail-content-" + spotId).css('display', 'none');
                            $(".js-rate-detail-button-triangle-" + spotId).css('border-top', '4px solid #3E82E9');
                            $(".js-rate-detail-button-triangle-" + spotId).css('border-bottom', '');
                        }
                    });
                };
                return RateDetailView;
            }(Fily.BaseView));
            SpotComponent.RateDetailView = RateDetailView;
        })(SpotComponent = PC.SpotComponent || (PC.SpotComponent = {}));
    })(PC = Fily.PC || (Fily.PC = {}));
})(Fily || (Fily = {}));
